<template>

	<footer class="col-xs-12 corte2 footer">
		<div class="col-xs-12 footer__top">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-md-6 footer__suscribete">
						<div class="footer__wrp">


							<h3>SUSCRIBIRTE A NUESTRO<br>NEWSLETTER</h3>
							<form action="https://newsletter.cerocin.co/subscribe" method="POST" accept-charset="utf-8" target="_blank">
								<input type="email" name="email" id="email"/>
								<input type="hidden" name="list" value="wuBzgEyMO0RAk5ue892l8KXA"/>
								<!-- <input type="submit" value="enviar"> -->
								<input type="submit" name="submit" id="submit"/>
							</form>


						</div>
					</div>
					<div class="col-xs-12 col-md-6 footer__segui">
						<div class="shadow footer__wrp">
							<h3>SEGUINOS EN REDES SOCIALES</h3>
							<!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing.</p> -->
							<ul>
								<li v-for="(value, key) in sm">
									<a v-bind:href="value" target="_blank">
										<span v-html="key.split('-')[1].toUpperCase()"></span>
										<i v-bind:class="'fa '+key"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 footer__bar">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-xs-6">
						<img v-bind:src="theme_url+'/html/assets/img/logo.png'" alt="">
						<span>©2017 {{ site_name }}</span>
					</div>
					<div class="col-xs-12 col-xs-6 text-right">
						<a href="https://cerocin.co">Desarrollado por Cerocinco</a>
					</div>
				</div>
			</div>
		</div>
	</footer>

</template>

<script>

export default {
	mounted: function() {
		this.getSM();
	},
	data() {
		return {
			site_name: rtwp.site_name,
			theme_url: rtwp.theme_url,
			sm: []
		};
	},
	methods: {
		getSM: function() {
			const vm = this;
			vm.$http.get( 'yoast/sm' )
			.then( ( res ) => {
				vm.sm = res.data;
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				console.log( 'Something went wrong :'+res );
			} );
		}
	}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// theme-footer.vue?f79c8fcc